<template>
    <section class="section">
        <div class="container is-max-desktop " id="app">
            <calc></calc>
        </div>
    </section>
</template>

<script>

import Calc from "./components/Calc.vue";

export default {
  name: "App",
  components: {
    Calc
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 350px;
}

</style>
